// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* チェックボックス群を折り返し表示 */
.check-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

/* 各アイテムの幅。狭い画面で自動的に縦に折れる */
.check-wrap .check-item {
  /* 1列の最低幅を決めて、余白に応じて複数列化 */
  flex: 1 1 150px;        /* 基準幅 220px、余れば並ぶ・足りなければ折り返す */
  min-width: 150px;       /* これ以下には縮めない */
}

/* ラベルの改行を許可（Carbon の label クラス） */
.check-wrap .cds--checkbox-label {
  white-space: normal;
  line-height: 1.4;
  word-break: break-word; /* 長い語が来ても折り返す */
}

/* さらに狭い時は1列に落とす */
@media (max-width: 480px) {
  .check-wrap .check-item {
    flex-basis: 100%;
    min-width: 0;
  }
}

/* ▼ モード切替（期間/日付）— 通常は1行、狭い画面だけ折り返し */
.aiq-mode-inline {
  display: flex;            /* Carbonに被せて明示 */
  align-items: center;
  gap: 0.75rem;
  flex-wrap: nowrap;        /* ← ふだんは改行しない */
}

/* 子のラッパが横幅を食い尽くさないように固定化 */
.aiq-mode-inline .cds--radio-button-wrapper {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;           /* ← 収縮/拡張させない */
  margin-right: 0;          /* Carbonの余白対策 */
}

/* ラベル内のテキスト自体に nowrap を強制（ここが重要） */
.aiq-mode-inline .cds--radio-button__label,
.aiq-mode-inline .cds--radio-button__label-text {
  white-space: nowrap;      /* ← 日本語の1文字ごとの改行を抑止 */
}

/* 狭い幅では折り返し解禁（2段に落ちる） */
@media (max-width: 560px) {
  .aiq-mode-inline {
    flex-wrap: wrap;        /* ← 折り返しOK */
    row-gap: 0.5rem;
  }
  .aiq-mode-inline .cds--radio-button__label,
  .aiq-mode-inline .cds--radio-button__label-text {
    white-space: normal;    /* ← ラベル内も改行OKに戻す */
  }
}

/* ---- Radio 横並び時の微ズレ修正 ---- */
/* ラッパを “横並び・中央揃え” に強制 */
.aiq-mode-inline .cds--radio-button-wrapper {
  display: inline-grid;              /* ← inline-flexでもOKだが gridのほうが安定 */
  grid-auto-flow: column;
  align-items: center;               /* 縦中央 */
  column-gap: 0.5rem;                /* ラジオと文字の間隔 */
}

/* ラベルの行間を詰め、ベースライン差を減らす */
.aiq-mode-inline .cds--radio-button__label,
.aiq-mode-inline .cds--radio-button__label-text {
  line-height: 1;                    /* ← ここが効く */
  white-space: nowrap;               /* 既存のnowrap指定は維持 */
}

/* 丸い見た目(疑似ラジオ)の縦位置を中央に固定 */
.aiq-mode-inline .cds--radio-button__appearance {
  align-self: center;
  margin-top: 0;                     /* Carbonの微妙なtopマージンを打ち消し */
}

/* 極小幅で折り返した時も中央位置を維持 */
@media (max-width: 560px) {
  .aiq-mode-inline .cds--radio-button-wrapper {
    display: grid;
    grid-auto-flow: column;
    align-items: center;
  }
  .aiq-mode-inline .cds--radio-button__label,
  .aiq-mode-inline .cds--radio-button__label-text {
    line-height: 1.2;                /* 折返し時は少しだけ行間戻すと読みやすい */
    white-space: normal;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AiInterviewQuestions.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA,2BAA2B;AAC3B;EACE,0BAA0B;EAC1B,eAAe,SAAS,+BAA+B;EACvD,gBAAgB,QAAQ,eAAe;AACzC;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB,EAAE,gBAAgB;AAC1C;;AAEA,kBAAkB;AAClB;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA,qCAAqC;AACrC;EACE,aAAa,aAAa,iBAAiB;EAC3C,mBAAmB;EACnB,YAAY;EACZ,iBAAiB,SAAS,gBAAgB;AAC5C;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc,YAAY,gBAAgB;EAC1C,eAAe,WAAW,gBAAgB;AAC5C;;AAEA,mCAAmC;AACnC;;EAEE,mBAAmB,OAAO,sBAAsB;AAClD;;AAEA,wBAAwB;AACxB;EACE;IACE,eAAe,SAAS,aAAa;IACrC,eAAe;EACjB;EACA;;IAEE,mBAAmB,KAAK,mBAAmB;EAC7C;AACF;;AAEA,+BAA+B;AAC/B,wBAAwB;AACxB;EACE,oBAAoB,eAAe,mCAAmC;EACtE,sBAAsB;EACtB,mBAAmB,gBAAgB,QAAQ;EAC3C,kBAAkB,iBAAiB,cAAc;AACnD;;AAEA,0BAA0B;AAC1B;;EAEE,cAAc,qBAAqB,YAAY;EAC/C,mBAAmB,gBAAgB,mBAAmB;AACxD;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,aAAa,sBAAsB,2BAA2B;AAChE;;AAEA,uBAAuB;AACvB;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;EACA;;IAEE,gBAAgB,iBAAiB,wBAAwB;IACzD,mBAAmB;EACrB;AACF","sourcesContent":["/* チェックボックス群を折り返し表示 */\n.check-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n/* 各アイテムの幅。狭い画面で自動的に縦に折れる */\n.check-wrap .check-item {\n  /* 1列の最低幅を決めて、余白に応じて複数列化 */\n  flex: 1 1 150px;        /* 基準幅 220px、余れば並ぶ・足りなければ折り返す */\n  min-width: 150px;       /* これ以下には縮めない */\n}\n\n/* ラベルの改行を許可（Carbon の label クラス） */\n.check-wrap .cds--checkbox-label {\n  white-space: normal;\n  line-height: 1.4;\n  word-break: break-word; /* 長い語が来ても折り返す */\n}\n\n/* さらに狭い時は1列に落とす */\n@media (max-width: 480px) {\n  .check-wrap .check-item {\n    flex-basis: 100%;\n    min-width: 0;\n  }\n}\n\n/* ▼ モード切替（期間/日付）— 通常は1行、狭い画面だけ折り返し */\n.aiq-mode-inline {\n  display: flex;            /* Carbonに被せて明示 */\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: nowrap;        /* ← ふだんは改行しない */\n}\n\n/* 子のラッパが横幅を食い尽くさないように固定化 */\n.aiq-mode-inline .cds--radio-button-wrapper {\n  display: inline-flex;\n  align-items: center;\n  flex: 0 0 auto;           /* ← 収縮/拡張させない */\n  margin-right: 0;          /* Carbonの余白対策 */\n}\n\n/* ラベル内のテキスト自体に nowrap を強制（ここが重要） */\n.aiq-mode-inline .cds--radio-button__label,\n.aiq-mode-inline .cds--radio-button__label-text {\n  white-space: nowrap;      /* ← 日本語の1文字ごとの改行を抑止 */\n}\n\n/* 狭い幅では折り返し解禁（2段に落ちる） */\n@media (max-width: 560px) {\n  .aiq-mode-inline {\n    flex-wrap: wrap;        /* ← 折り返しOK */\n    row-gap: 0.5rem;\n  }\n  .aiq-mode-inline .cds--radio-button__label,\n  .aiq-mode-inline .cds--radio-button__label-text {\n    white-space: normal;    /* ← ラベル内も改行OKに戻す */\n  }\n}\n\n/* ---- Radio 横並び時の微ズレ修正 ---- */\n/* ラッパを “横並び・中央揃え” に強制 */\n.aiq-mode-inline .cds--radio-button-wrapper {\n  display: inline-grid;              /* ← inline-flexでもOKだが gridのほうが安定 */\n  grid-auto-flow: column;\n  align-items: center;               /* 縦中央 */\n  column-gap: 0.5rem;                /* ラジオと文字の間隔 */\n}\n\n/* ラベルの行間を詰め、ベースライン差を減らす */\n.aiq-mode-inline .cds--radio-button__label,\n.aiq-mode-inline .cds--radio-button__label-text {\n  line-height: 1;                    /* ← ここが効く */\n  white-space: nowrap;               /* 既存のnowrap指定は維持 */\n}\n\n/* 丸い見た目(疑似ラジオ)の縦位置を中央に固定 */\n.aiq-mode-inline .cds--radio-button__appearance {\n  align-self: center;\n  margin-top: 0;                     /* Carbonの微妙なtopマージンを打ち消し */\n}\n\n/* 極小幅で折り返した時も中央位置を維持 */\n@media (max-width: 560px) {\n  .aiq-mode-inline .cds--radio-button-wrapper {\n    display: grid;\n    grid-auto-flow: column;\n    align-items: center;\n  }\n  .aiq-mode-inline .cds--radio-button__label,\n  .aiq-mode-inline .cds--radio-button__label-text {\n    line-height: 1.2;                /* 折返し時は少しだけ行間戻すと読みやすい */\n    white-space: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
